<template>
  <div>
    <v-btn
      :color="COLORS.grainfoxAIButton"
      class="white--text"
      :small="$isMobile"
      :class="{'mr-2' : !$isMobile}"
      @click="openSinoaGuideDialog = true"
    >
      <v-icon
        :left="!$isMobile"
        :small="$isMobile"
      >
        mdi-book-open-page-variant
      </v-icon>
      <span
        v-if="!$isMobile"
      >
        Guide
      </span>
    </v-btn>

    <v-btn
      text
      :icon="$isMobile"
      :disabled="isSinoaLoading"
      @click="$emit('toggle-history')"
    >
      <v-icon v-if="$isMobile">
        mdi-history
      </v-icon>
      <span v-else>
        {{ showingHistory ? 'HIDE HISTORY' : 'HISTORY' }}
      </span>
    </v-btn>

    <v-btn
      icon
      @click="$emit('toggle-fullscreen')"
    >
      <v-icon>{{ fullScreen ? 'mdi-arrow-collapse' : 'mdi-arrow-expand' }}</v-icon>
    </v-btn>

    <!-- Close button - hidden in panel mode -->
    <v-btn
      v-if="!hideCloseButton"
      icon
      data-qa="sinoa-close-btn"
      @click="$emit('close-dialog')"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <SinoaGuideDialog
      :value="openSinoaGuideDialog"
      @input="openSinoaGuideDialog = false"
    />
  </div>
</template>

<script>
import { COLORS } from '@/helpers/colors';
import { mapGetters } from 'vuex';
import SinoaGuideDialog from './SinoaGuideDialog.vue';

export default {
  name: 'SinoaActions',

  components: {
    SinoaGuideDialog,
  },

  props: {
    fullScreen: {
      type: Boolean,
      default: false,
    },

    showingHistory: {
      type: Boolean,
      default: false,
    },

    /**
     * Whether to hide the close button
     * Used in panel mode where close is not applicable
     * @type {boolean}
     */
    hideCloseButton: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      COLORS,
      openSinoaGuideDialog: false,
    };
  },

  computed: {
    ...mapGetters('chatbot', ['isSinoaLoading']),
  },
};
</script>
